import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import { PublicWebService } from '../public-web.service';

@Component({
  selector: 'app-vjdist-search',
  templateUrl: './vjdist-search.component.html',
  styleUrls: ['./vjdist-search.component.css'],
})
export class VJDistSearchComponent implements OnInit {
  isLoading: boolean = false;
  isDataLoading: boolean = false;
  searchForm: FormGroup;
  vjOfficeCountry: { value: string; label: string }[] = []; // Modify the declaration
  vjDataList: any[];
  vjDistributorList: any[];
  selectedCountry: string | null = null;
  searchPerformed: boolean = false;
  selectedType: string = 'all';
  selectedIndex: number = 0;

  private readonly unsubscribe$: Subject<void> = new Subject();

  constructor(
    private fb: FormBuilder,
    private publicService: PublicWebService
  ) {
    this.searchForm = this.fb.group({
      country: [''],
      narrowSearch: [''],
    });
  }

  ngOnInit(): void {
    this.getDDLCountrys();
    this.formCountryChange();
  }

  changeTab() {
    if (this.selectedIndex == 0) {
      this.getDistributors();
    } else if (this.selectedIndex == 1) {
      this.getOffices();
    } else {
      this.getDistributors();
      this.getOffices();
    }
  }

  formCountryChange() {
    this.searchForm
      .get('country')
      ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((selectedCountry) => {
        this.selectedCountry = selectedCountry;
        this.getDistributors();
        this.getOffices();
      });
  }

  // getting all countries in country dropdown

  getDDLCountrys() {
    this.isLoading = true;
    this.publicService
      .getVideojetCountries()
      .pipe(
        tap(() => {
          this.isLoading = true;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (value) => {
          this.vjOfficeCountry = value.map((item) => ({
            value: item.countryCode,
            label: item.countryName,
          }));
          this.isLoading = false;
        },
        complete() {},
        error(err) {
          this.isLoading = false;
        },
      });
  }

  // getting both videojet offices and distributors data combined

  getDistributors() {
    this.isDataLoading = true;
    this.publicService
      .getVideojetDistributors(this.selectedCountry)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (distributorsData) => {
          this.vjDistributorList = distributorsData;
          this.isDataLoading = false;
        },
        complete() {},
        error(err) {
          this.isDataLoading = false;
        },
      });
  }
 
  getOffices() {
    this.isDataLoading = true;
    this.publicService
      .getVideojetOffices(this.selectedCountry)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (officesData) => {
          this.vjDataList = officesData;
          this.isDataLoading = false;
        },
        complete() {},
        error(err) {
          this.isDataLoading = false;
        },
      });
  }

  clearSearch(inputValue) {}
}
